import { CheckCircle2, Loader2 } from "lucide-react";

export function NarrativePanel({ a }) {
  const n = a.narrative;
  return (
    <section className="panel space-y-4 p-5" data-tour="pt-narrative-panel" data-testid="narrative-panel">
      <h3 className="text-base font-semibold">Summary</h3>
      {!n ? (
        <p className="flex items-center gap-2 text-sm text-ink-muted" data-testid="narrative-pending">
          {a.narrative_status === "failed" ? "The summary couldn't be written. Scores above are unaffected." : <><Loader2 size={14} className="animate-spin" /> Writing a plain-language summary…</>}
        </p>
      ) : (
        <>
          <p className="leading-relaxed text-ink-secondary" data-testid="narrative-summary">{n.summary}</p>
          <div className="grid gap-4 sm:grid-cols-2">
            <div><p className="mb-1 text-sm font-medium">How to get the best from this person</p><ul className="list-disc space-y-1 pl-5 text-sm text-ink-secondary" data-testid="narrative-best">{n.best_from.map((x) => <li key={x}>{x}</li>)}</ul></div>
            <div><p className="mb-1 text-sm font-medium">Areas to probe in interview</p><ul className="list-disc space-y-1 pl-5 text-sm text-ink-secondary" data-testid="narrative-probe">{n.probe.map((x) => <li key={x}>{x}</li>)}</ul></div>
          </div>
          <p className="text-[11px] text-ink-muted">Written by AI from the scores above. Review before sharing.</p>
        </>
      )}
    </section>
  );
}

export function SjtResults({ sjt }) {
  if (!sjt) return null;
  return (
    <section className="panel space-y-3 p-5" data-tour="pt-sjt-results" data-testid="sjt-results">
      <div className="flex items-baseline justify-between"><h3 className="text-base font-semibold">Situational judgement</h3><span className="font-display text-2xl font-semibold tabular-nums" data-testid="sjt-score">{sjt.score}</span></div>
      <div className="flex flex-wrap gap-2 text-xs">{Object.entries(sjt.by_type).map(([k, v]) => <span key={k} className="rounded-full border border-line px-2.5 py-0.5 capitalize text-ink-secondary">{k} {v}</span>)}</div>
      <ul className="space-y-2 text-sm">
        {sjt.items.map((it) => (
          <li key={it.id} className="rounded-[6px] border border-line p-3">
            <p className="text-ink">{it.scenario}</p>
            <p className="mt-1 text-xs text-ink-secondary">Chose: {it.chosen || "—"} <span className="tabular-nums text-ink-muted">({it.points}/{it.max})</span></p>
            {it.points < it.max && <p className="text-xs text-success">Best: {it.best_option}</p>}
          </li>
        ))}
      </ul>
    </section>
  );
}

export function ValidityPanel({ a }) {
  const v = a.results.validity;
  const rows = [["Consistency index", v.consistency_index != null ? `${v.consistency_index}/100` : "—"], ["Attention checks", `${v.attention_passed} of ${v.attention_total} passed`],
    ["Longest same-answer run", v.longest_run], ["Median time per item", `${(v.median_ms / 1000).toFixed(1)}s`], ["Tab switches", a.tab_switches],
    ["Total time", `${Math.round(a.total_time_ms / 60000)} min`], ["Device", a.device || "—"]];
  return (
    <section className="panel space-y-2 p-5" data-tour="pt-validity-panel" data-testid="validity-panel">
      <h3 className="text-base font-semibold">Answer quality</h3>
      {v.reasons.length === 0 ? <p className="flex items-center gap-2 text-sm text-success"><CheckCircle2 size={14} /> No quality concerns.</p> : <ul className="list-disc pl-5 text-sm text-caution">{v.reasons.map((r) => <li key={r}>{r}</li>)}</ul>}
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs">{rows.map(([k, val]) => <div key={k} className="contents"><dt className="text-ink-muted">{k}</dt><dd className="truncate text-ink">{val}</dd></div>)}</dl>
      <p className="text-[11px] text-ink-muted">{a.results.norms_source}</p>
    </section>
  );
}
